import { useState, useEffect, useCallback, ReactNode } from "react";
import { MESSAGE_VARIANT, ROUTE_URLS } from "../../constants/consts";
import "./Message.sass";
import { Alert, Grow } from "ui";
import { useNavigate } from "react-router-dom";

interface MessageProps {
  variant: MESSAGE_VARIANT;
  children: ReactNode;
  timeout?: number;
  hideMessage: VoidFunction;
  shouldRedirectByClick?: boolean;
  redirectPath?: string;
}

const Message = (props: MessageProps) => {
    const navigate = useNavigate();
  const {
    variant,
    children,
    timeout,
    hideMessage,
    shouldRedirectByClick,
    redirectPath,
  } =
    props;
  const [massageTimeId, setMassageTimeId] = useState<
    NodeJS.Timeout | undefined
  >(undefined);
  const hasChildren = Boolean(children);

  useEffect(() => {
    const timeId = setTimeout(() => {
      hideMessage();
    }, timeout || 4000);

    setMassageTimeId(timeId);
    return () => {
      clearTimeout(timeId);
    };
  }, [children, hideMessage, timeout, variant]);

  const onClick = useCallback((event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    hideMessage();
    clearTimeout(massageTimeId);
    navigate(redirectPath || `${ROUTE_URLS.ORDERS}`);
  }, [hideMessage, massageTimeId, navigate, redirectPath]);

  const handleClose = () => {
    hideMessage();
    clearTimeout(massageTimeId);
  };

  if (!children) {
    return null;
  }

  return (
    <div className={`message_alert`} onClick={shouldRedirectByClick ? onClick : undefined}>
      <Grow
        in={hasChildren}
        style={{ transformOrigin: "0 0 0" }}
        {...(hasChildren ? { timeout: 500 } : {})}
      >
        <Alert
          severity={variant}
          onClose={handleClose}
          sx={{ whiteSpace: "pre-line" }}
        >
          {children}
        </Alert>
      </Grow>
    </div>
  );
};

export default Message;
